import React from 'react'

export const About = () => (
  <div className="jumbotron">
    <div className="container">
      <h1 className="display-4">React приложение для пунтка приема металлолома</h1>
      <p className="lead">
        Версия приложения <strong>1.4.88</strong>
      </p>
      <p>
        Сделал: <strong>Байцуров В.В</strong>
      </p>
    </div>
  </div>
)
